import { render, staticRenderFns } from "./TwoColumnsSection.vue?vue&type=template&id=b1fd735c&scoped=true"
import script from "./TwoColumnsSection.vue?vue&type=script&lang=js"
export * from "./TwoColumnsSection.vue?vue&type=script&lang=js"
import style0 from "./TwoColumnsSection.vue?vue&type=style&index=0&id=b1fd735c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fd735c",
  null
  
)

export default component.exports